import { styled } from "@mui/material";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { Suspense } from "react";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { UploadMeasureGuard } from "components/upload/UploadMeasureGuard";
import { ErrorBoundary } from "react-error-boundary";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { MeasuresPageSkeleton } from "components/skeletons/MeasuresPageSkeleton";

export function UploadMeasurePage() {
  const { mapRef, footerRef, uuid, mapOverlayContainer } =
    useUuidLayoutContext();

  return (
    <StyledPaddedPaper>
      <ErrorBoundary FallbackComponent={AlertErrorBoundary}>
        <Suspense
          fallback={
            <MeasuresPageSkeleton
              footerRef={footerRef}
              mapOverlayContainer={mapOverlayContainer}
            />
          }
        >
          <UploadMeasureGuard
            footerRef={footerRef}
            uuid={uuid}
            mapRef={mapRef}
          />
        </Suspense>
      </ErrorBoundary>
    </StyledPaddedPaper>
  );
}
const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(4)};
`;
